import React from "react";
import PropTypes from "prop-types";
import ImmutablePropTypes from 'react-immutable-proptypes';
import Slider from "react-slick";

// START_HERE: why does the left-arm facing have a $300 upcharge
import Component from "components/component";
import {
  isSelectable,
  shouldOptionRowUpdate,
  updateSliderOnOpenToggle
} from "lib/helpers";

import DefaultOption from "./default-option";
import DefaultOptionSelection from "./default-option-selection";
import SelectionPrompt from "./selection-prompt";

const leftArmFacing = 'left_arm_facing';
const rightArmFacing = 'right_arm_facing';

const settings = {
  speed: 500,
  dots: false,
  arrows: false,
  infinite: false,
  draggable: true,
  focusOnSelect: false,
  slidesToShow: 3,
  swipeToSlide: true,
  centerMode: false
};

export default class DaybedOrientationOptionRow extends Component {
  static propTypes = {
    optionType: ImmutablePropTypes.map,
    optionValues: ImmutablePropTypes.map.isRequired,
    selection: ImmutablePropTypes.map,
    handleClick: PropTypes.func.isRequired,
    selections: ImmutablePropTypes.map,
    optionValueRestrictions: ImmutablePropTypes.map,
    quantityCount: PropTypes.number.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      showAdditionalOptions: false,
      matches: window.matchMedia("(min-width: 2000px)").matches
    };
  }

  shouldComponentUpdate(newProps, newState) {
    return shouldOptionRowUpdate(newProps, newState, this);
  }

  toggleOpen = e => {
    if (e) e.preventDefault();
    this.setState({ isOpen: !this.state.isOpen });
  };

  showMore = e => {
    e.preventDefault();
    this.setState({ showAdditionalOptions: true });
  };

  getThumbnailImageUrl = optionValue => {
    const { product } = this.props;
    if (optionValue.get('name') === leftArmFacing) {
      const thumbnail = product.get('handedImagePaths').find(path => {
        return path.includes(`${product.get('slug')}-laf`);
      });

      if (thumbnail) {
        return thumbnail;
      }
    }

    if (optionValue.get('name') === rightArmFacing) {
      const thumbnail = product.get('handedImagePaths').find(path => {
        return path.includes(`${product.get('slug')}-raf`);
      });

      if (thumbnail) {
        return thumbnail;
      }
    }
  }

  componentDidMount() {
    const handler = e => this.setState({matches: e.matches});
    window.matchMedia("(min-width: 768px)").addEventListener('change', handler);
  }

  UNSAFE_componentDidUpdate(oldProps, oldState) {
    updateSliderOnOpenToggle(oldState, this);
  }

  render() {
    if (this.props.optionValues.isEmpty()) return null;

    const { isOpen, showAdditionalOptions } = this.state;
    const {
      optionType,
      optionValues,
      selection,
      handleClick,
      selections,
      optionValueRestrictions,
      quantityCount,
      product,
    } = this.props;
    const optionName = optionType.get("displayName");
    const toggleClass = isOpen ? "toggle-row open" : "toggle-row";
    const selectionIsPresent = !!selection;
    let selectionId,
      selectionName,
      selectionUpchargeAmount,
      selectionImage,
      selectionDisplayUpchargeAmount;
    let selectionIndex = 0;

    if (selectionIsPresent) {
      selectionId = selection.get("id");
      selectionName = selection.get("displayName");
      selectionUpchargeAmount = selection.get("upchargeAmount");
      selectionImage = selection.get("thumbnailImage");
      selectionIndex = optionValues
        .valueSeq()
        .findIndex(ov => ov.get("id") === selectionId);
      selectionDisplayUpchargeAmount = selection.get("displayUpchargeAmount");
    }

    const firstTwelveValues = optionValues.slice(0, 12);
    const remainingValues = optionValues.slice(13, optionValues.length);

    return (
      <div>
        <div className="product-options-title-row desktop-only">
          <p className="lined-title">
            <span>{optionName}</span>
          </p>
        </div>

        <div className="product-options-row option-columns three-columns">
          <div className="product-options-wrapper-mobile mobile-only">
            <a href="#" className={toggleClass} onClick={this.toggleOpen} />

            {!isOpen && !selectionIsPresent && (
              <div>
                <p className="option-name">{optionName}</p>
                <SelectionPrompt name={selectionName} />
              </div>
            )}

            {!isOpen && selectionIsPresent && (
              <DefaultOptionSelection
                optionName={optionName}
                selectionName={selectionName}
                upchargeAmount={selectionUpchargeAmount}
                thumbnailImage={selectionImage}
                displayUpchargeAmountOverride={selectionDisplayUpchargeAmount}
                quantityCount={quantityCount}
                showQuantity={
                  selectionUpchargeAmount > 0 && quantityCount > 1
                }
              />
            )}

            <div style={{ display: isOpen ? "block" : "none" }}>
              <p className="option-name">{optionName}</p>
              <div className="product-options-slider-wrapper">
                <Slider {...settings} slickGoTo={selectionIndex} ref="slider">
                  {optionValues.valueSeq().map((optionValue, key) => {
                    const id = optionValue.get("id");
                    const selectable = isSelectable(
                      selections,
                      optionValueRestrictions,
                      id
                    );

                    return (
                      <div key={id}>
                        <DefaultOption
                          optionValue={optionValue}
                          isSelected={selectionId === id}
                          handleClick={handleClick}
                          selectable={selectable}
                          inSlider
                        />
                      </div>
                    );
                  })}
                </Slider>
              </div>
            </div>
          </div>

          <div className="desktop-only" style={{ width: '100%' }}>

            <div className="options-container" style={{
              display: 'flex',
              justifyContent: 'center',
            }}>
              {firstTwelveValues.valueSeq().map((optionValue, key) => {
                const id = optionValue.get("id");
                const selectable = isSelectable(
                  selections,
                  optionValueRestrictions,
                  id
                );
                const noMargin = (key + 1) % 3 === 0;

                const thumbnailImageOverride = this.getThumbnailImageUrl(optionValue);

                return (
                  <DefaultOption
                    key={id}
                    optionValue={optionValue}
                    thumbnailImageOverride={thumbnailImageOverride}
                    isSelected={selectionId === id}
                    handleClick={handleClick}
                    selectable={selectable}
                    noMargin={noMargin}
                    containerStyles={{
                      flex: '0 0 48%',
                      paddingTop: 40,
                    }}
                    imageStyles={{ width: this.state?.matches ? '50%' : '66%' }}
                  />
                );
              })}

              {remainingValues.size !== 0 && !showAdditionalOptions && (
                <button
                  className="show-more-button large center"
                  onClick={this.showMore}
                >
                  Show More
                </button>
              )}

              <div className="additional-options">
                {showAdditionalOptions &&
                  remainingValues.valueSeq().map((optionValue, key) => {
                    const id = optionValue.get("id");
                    const selectable = isSelectable(
                      selections,
                      optionValueRestrictions,
                      id
                    );

                    return (
                      <DefaultOption
                        key={id}
                        optionValue={optionValue}
                        isSelected={selectionId === id}
                        handleClick={handleClick}
                        selectable={selectable}
                        containerStyles={{
                          flex: '0 0 48%',
                          paddingTop: 40,
                        }}
                        imageStyles={{ width: '66%' }}
                      />
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
